import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) { }

  userLogins(start_date) {
    return this.http.get<any>(`${environment.apiUrl}/dashboard/logins/`+start_date)
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));
  }

  userVideos(start_date) {
    return this.http.get<any>(`${environment.apiUrl}/dashboard/videos/`+start_date)
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));
  }

  userPoints(start_date) {
    return this.http.get<any>(`${environment.apiUrl}/dashboard/points/`+start_date)
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));
  }

  adminUsers(start_date) {
    return this.http.get<any>(`${environment.apiUrl}/admin/dashboard/signups/`+start_date)
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));
  }

  adminOrganisations(start_date) {
    return this.http.get<any>(`${environment.apiUrl}/admin/dashboard/organisations/`+start_date)
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));
  }

  adminRevenue(start_date) {
    return this.http.get<any>(`${environment.apiUrl}/admin/dashboard/revenue/`+start_date)
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));
  }

  userLoginsAdmin(start_date, organisation_id) {
    return this.http.get<any>(`${environment.apiUrl}/admin/dashboard/logins/`+start_date+`/`+organisation_id)
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));
  }

  userVideosAdmin(start_date, organisation_id) {
    return this.http.get<any>(`${environment.apiUrl}/admin/dashboard/videos/`+start_date+`/`+organisation_id)
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));
  }

  userPointsAdmin(start_date, organisation_id) {
    return this.http.get<any>(`${environment.apiUrl}/admin/dashboard/points/`+start_date+`/`+organisation_id)
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));
  }
}
